import { trim, truncate, isEmpty } from 'lodash';
import moment from 'moment-timezone';

//trim notes
export function trimAndLimit(text, limit = 250) {

    if(!isEmpty(text)){
        // Remove HTML tags using DOMParser
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const plainText = doc.body.textContent || '';
        
        // Trim whitespace and limit to 250 characters
        const trimmedText = truncate(trim(plainText), { length: limit });
    
        return !isEmpty(trimmedText)? trimmedText : '';
    }
    return text;
    
}

export function getFormatedDateTime(dateStr, format = 'MM/DD/YY H:mm:ss'){
    return moment(dateStr).format(format);
}